export const WarehouseTypeGroup = [
  { label: '本社管轄倉庫', value: '1' },
  { label: '本社管轄倉庫', value: '2' },
  { label: '委託管轄倉庫', value: '3' },
];
